// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_1DLzNHCMJp9Wd-afZ0JfsB"};